import { ButtonGroupRoundButtonSkeleton } from 'ui/components/v2/ButtonGroup/Buttons/Skeleton';

export const MakeButtonSkeletons = ({ cols }: { cols: number }) => {
  const items = Array(cols).fill(0);
  return items.map((_, index) => {
    return <ButtonGroupRoundButtonSkeleton key={index} />;
  });
};
